import {
    SEND_LOGIN_REQUEST,

    SEND_SIGNUP_REQUEST,
    SEND_ACTIVATECODE_REQUEST,
    SEND_ACTIVEACCOUNT_REQUEST,
    SEND_CHECKPASSWORDRESETCODE_REQUEST,
    SEND_FORGETPASSWORD_REQUEST,
    SEND_NEWPASSWORD_REQUEST,
    SEND_PROMOTIONINFO_REQUEST,
    REQUEST_ERROR,
    CLEAR_ERROR,
    

} from './constants'

export function clearerror(){
    return {type: CLEAR_ERROR}
}

/**
 * Tells the app customer wants to login
 * @param  {object} data          The data we're sending to login
 * @param  {string} data.email    The user id / email of customer
 * @param  {string} data.password    The password of customer
 */
export function login(data) {
    return { type: SEND_LOGIN_REQUEST, data }
}

/**
 * Tells the app customer wants to retrieve his rewards
 */
export function retrieveRewards() {
    //console.log("redux actoins retrieve rewards");
    return { type: SEND_PROMOTIONINFO_REQUEST }
}

/**
 * Tells the app customer wants to signup
 * @param  {object} data          The data we're sending to login
 * @param  {string} data.policyNumber    The policy number of prestige customer
 * @param  {string} data.firstname    The firstname of customer
 * @param  {string} data.lastname    The lastname of customer
 * @param  {string} data.email    The user id / email of customer
 * @param  {string} data.password    The password of customer
 */
export function signup(data) {
    //console.log("redux actoins retrieve signUp Successful page");
    return { type: SEND_SIGNUP_REQUEST, data}
}


/**
 * Tells the app customer wants to signup
 * @param  {object} data          The data we're sending to login
 * @param  {string} data.activatecode    The password of customer
 */
export function activeaccount(data) {
    //console.log("redux actoins retrieve active account page");
    return { type: SEND_ACTIVEACCOUNT_REQUEST, data}
}

export function checkPasswordResetCode(data){
    //console.log("redux actoins retrieve check Password Reset page");
    return { type: SEND_CHECKPASSWORDRESETCODE_REQUEST, data}
}

/**
 * Tells the app customer wants to forgot password
 * @param  {object} data          The data we're sending to login
 * @param  {string} data.emailaddress    The password of customer
 */
export function sendpasswordresetcode(data) {
    //console.log("redux actoins retrieve forgot password page");
    return { type: SEND_FORGETPASSWORD_REQUEST, data}
}


/**
 * Tells the app customer wants to forgot password
 * @param  {object} data          The data we're sending to login
 * @param  {string} data.emailaddress    The password of customer
 */
export function sendactivatecode(data) {
    //console.log(data);
    return { type: SEND_ACTIVATECODE_REQUEST, data}
}


/**
 * Tells the app customer wants to forgot password
 * @param  {object} data          The data we're sending to login
 * @param  {string} data.password    The password of customer
 * @param  {string} data.pwdResetCode    The password of customer
 */
export function setNewPassword(data) {
    //console.log("redux actoins retrieve set new password page");
    return { type: SEND_NEWPASSWORD_REQUEST, data}
}

/**
 * Sets the `error` state to the error received
 * @param  {object} error The error we got when trying to make the request
 */
export function requestError(error) {
    return { type: REQUEST_ERROR, error }
}
